import { useMemo, useState } from "react";
import { hospitalDashboardData } from "../../data/hospitalDashboard";
import type { HospitalDashboardViewData } from "../../api/mapHospitalDashboard";
import { HospitalDashboardInvoiceFilters } from "./HospitalDashboardInvoiceFilters";
import { HospitalSubmittedInvoicesTable, parseSubmittedDate } from "./HospitalSubmittedInvoicesTable";
import { HospitalTopClientsCard } from "./HospitalTopClientsCard";

export function HospitalDashboardClientsSection({
  data = hospitalDashboardData,
}: {
  data?: HospitalDashboardViewData;
}) {
  const [search, setSearch] = useState("");
  const [company, setCompany] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const filteredInvoices = useMemo(() => {
    return data.submittedInvoices.filter((invoice) => {
      const haystack = `${invoice.displayId} ${invoice.company}`.toLowerCase();
      const bySearch = search ? haystack.includes(search.toLowerCase()) : true;
      const byCompany = company ? invoice.company.toLowerCase() === company.toLowerCase() : true;

      const submittedDate = parseSubmittedDate(invoice.submittedDate);
      const fromDate = dateFrom ? new Date(dateFrom) : null;
      const toDate = dateTo ? new Date(dateTo) : null;
      const byFrom = fromDate && submittedDate ? submittedDate >= fromDate : true;
      const byTo = toDate && submittedDate ? submittedDate <= toDate : true;

      return bySearch && byCompany && byFrom && byTo;
    });
  }, [data.submittedInvoices, search, company, dateFrom, dateTo]);

  const resetFilters = () => {
    setSearch("");
    setCompany("");
    setDateFrom("");
    setDateTo("");
  };

  return (
    <div className="space-y-5">
      <HospitalTopClientsCard data={data} />
      <HospitalDashboardInvoiceFilters
        companyFilterOptions={data.companyFilterOptions}
        search={search}
        company={company}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onSearchChange={setSearch}
        onCompanyChange={setCompany}
        onDateFromChange={setDateFrom}
        onDateToChange={setDateTo}
        onReset={resetFilters}
      />
      <HospitalSubmittedInvoicesTable rows={filteredInvoices} />
    </div>
  );
}
